import { render } from "./Button.vue?vue&type=template&id=2cf64e09&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=2cf64e09&lang=scss"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__